import { LegacyRef, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '@/state';

export default function Banner() {
	const merchantBrand = useSelector((state: AppState) => state.userState.user?.merchant?.brand);
	const userName = useSelector((state: AppState) => state.userState.user?.name);

	const [isBannerLong, setIsBannerLong] = useState(false);
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	const merchantNameRef = useRef<HTMLSpanElement>(null);
	const outletDetailsRef = useRef<HTMLSpanElement>(null);
	const PADDING = 48;
	const GAP = 12;

	const getTextWidth = (text: string, font: string) => {
		const canvas = document.createElement('canvas');
		const context = canvas.getContext('2d');

		if (context) {
			context.font = font || getComputedStyle(document.body).font;
			return context.measureText(text).width;
		}

		return 0;
	};

	const handleResize = () => {
		setWindowWidth(window.innerWidth);
	}

	useEffect(() => {
		window.addEventListener('resize', handleResize);
		handleResize();
		return () => {
			window.removeEventListener('resize', handleResize);
		}
	}, []);

	useEffect(() => {
		if (merchantBrand && merchantNameRef.current && outletDetailsRef.current) {
			const merchantNameWidth = getTextWidth(merchantBrand, window.getComputedStyle(merchantNameRef.current).getPropertyValue('font'));
			const outletDetailsWidth = getTextWidth(userName, window.getComputedStyle(outletDetailsRef.current).getPropertyValue('font'));

			const screenWidth = window.innerWidth;
			if (merchantNameWidth === 0 || outletDetailsWidth === 0) return;
			setIsBannerLong(merchantNameWidth + outletDetailsWidth + PADDING + GAP >= screenWidth);
		}
	}, [merchantBrand, userName, windowWidth]);

	return (
		<div
			id='banner'
			className={`text-sm px-6 whitespace-break-spaces banner bg-blue-grey-darkest w-full flex justify-center items-center gap-1 tablet:gap-3 p-3 text-white text-center min-h-10 ${
				isBannerLong && 'flex-col'
			}`}>
			<span
				ref={merchantNameRef as unknown as LegacyRef<HTMLSpanElement>}
				id='merchantName'
				className={`font-semibold whitespace-break-spaces ${!isBannerLong && 'text-nowrap'}`}>
				{merchantBrand}
			</span>
			<span
				id='outletDetails'
				ref={outletDetailsRef as unknown as LegacyRef<HTMLSpanElement>}
				className={`flex gap-1 tablet:gap-3 whitespace-break-spaces items-center ${!isBannerLong && 'text-nowrap'}`}>
				{userName && <span>·</span>}
				<span>{userName}</span>
			</span>
		</div>
	);
}
